import axios from 'axios';
import {
  CreateProfileResponse,
  ExistingProfile,
  BaseFormProfile,
  GetProfilesQueryParams,
  GetProfilesResponse,
  GetSingleProfileQueryParams,
  GetSingleProfileResponse,
  UpdateProfileResponse
} from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/Settings/types/profileTypes';
import { store } from 'src/main';
import { getQueryParamValue } from 'src/utils/app';

const getRetailerIdFromQueryParam = (): number | undefined => {
  const rid = getQueryParamValue('rid', '');
  const retailerId = Number(rid);
  if (!Number.isFinite(retailerId) || retailerId <= 0) {
    return undefined;
  }
  return retailerId;
};

export const apiGetSingleProfile = async (args: GetSingleProfileQueryParams) => {
  const res = await axios.get<GetSingleProfileResponse>('/api/beaconcontent/GetProfile', {
    params: {
      profileId: args.profileId,
      version: args.version,
      retailerId: getRetailerIdFromQueryParam()
    }
  });
  if (!res.data.isSuccess) {
    throw new Error('Failed to fetch profile for the given ID: ' + args.profileId);
  }
  return res;
};

export const apiGetProfiles = async (args?: GetProfilesQueryParams) => {
  const retailerId = getRetailerIdFromQueryParam() ?? args?.retailerId;
  const res = await axios.get<GetProfilesResponse>('/api/beaconcontent/GetProfiles', {
    params: {
      status: args?.status,
      profileName: args?.profileName,
      retailerId
    }
  });
  if (!res.data.isSuccess) {
    throw new Error('Failed to fetch profiles with args: ' + args);
  }
  return res.data;
};

export const apiCreateProfile = async (body: BaseFormProfile) => {
  const payload: BaseFormProfile & { retailerId?: number } = { ...body, retailerId: getRetailerIdFromQueryParam() };
  const res = await axios.post<CreateProfileResponse>('/api/beaconcontent/CreateProfile', payload);
  return res;
};

/**
 * Somehow the backend team requires the full profile object to update the profile
 * instead of just the updated fields. This is a bit odd, but we have to follow it for now.
 */
export const apiUpdateProfile = async (body: ExistingProfile) => {
  const beaconClientId = store.getState().entityService.mainEntity.beaconClientId;
  const retailerId = getRetailerIdFromQueryParam();
  const res = await axios.post<UpdateProfileResponse>('/api/beaconcontent/UpdateProfile', {
    ...body,
    beaconClientId: beaconClientId,
    retailerId
  });
  return res;
};

export const apiArchiveProfile = async (profileId: string) => {
  const res = await axios.put(`/api/beaconcontent/ArchiveProfile`, null, {
    params: { profileId }
  });

  if (!res.data.isSuccess) {
    throw new Error('Failed to archive profile with id: ' + profileId);
  }

  return res;
};
